import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { Currency } from '@/types';
import { useDeleteCurrencyMutation } from '@/services';

export interface DeleteCurrencyProps extends DialogProps {
  currency: Currency;
  onClose(): void;
}

const DeleteCurrency: React.FC<DeleteCurrencyProps> = ({ currency, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteCurrency, deleteCurrencyResponse] = useDeleteCurrencyMutation();

  async function handleDeleteCurrency() {
    try {
      await deleteCurrency(currency).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{currency?.full_name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{currency?.full_name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button color="secondary" variant="outlined" disabled={deleteCurrencyResponse.isLoading} onClick={onClose}>
          Закрыть
        </Button>

        <Button variant="contained" disabled={deleteCurrencyResponse.isLoading} onClick={handleDeleteCurrency}>
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCurrency;
